/* =======================================================
   Read more toggle (KEEP AS IS)
======================================================= */
function toggleReadMore(element) {
  var sectionId = element.getAttribute("data-section-id");
  var dots = document.getElementById(sectionId + "_dots");
  var moreText = document.getElementById(sectionId + "_more");
  var btnText = document.getElementById(sectionId + "_myBtn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    moreText.style.display = "none";
    btnText.innerHTML = "read more";
  } else {
    dots.style.display = "none";
    moreText.style.display = "inline";
    btnText.innerHTML = "read less";
  }
}

/* =======================================================
   FIX: Prevent variant swatch focus from scrolling the page (mobile)
======================================================= */
(() => {
  if (window.__PREVENT_FOCUS_SCROLL_V1__) return;
  window.__PREVENT_FOCUS_SCROLL_V1__ = true;

  const isMobile = () =>
    window.matchMedia && window.matchMedia("(max-width: 749px)").matches;

  const origFocus = HTMLElement.prototype.focus;

  HTMLElement.prototype.focus = function (options) {
    try {
      if (!isMobile()) return origFocus.call(this, options);

      const el = this;
      const isVariantInput =
        el &&
        el.matches &&
        el.matches(
          ".swatch-input__input, variant-radios input, variant-selects select, .product-form__input input, .product-form__input select"
        );

      if (isVariantInput) {
        return origFocus.call(el, { preventScroll: true });
      }
    } catch (e) {}

    return origFocus.call(this, options);
  };
})();

/* =======================================================
   ✅ Variant Change Scheduler + Unified Orchestrator
   - Batches price / gallery work into one frame
   - Avoids duplicate runs for the same variant
   - Uses events first, light polling only as fallback
======================================================= */
(function () {
  if (window.__VARIANT_CHANGE_SCHEDULER_V2__) return;
  window.__VARIANT_CHANGE_SCHEDULER_V2__ = true;

  function getVariantIdInput() {
    return (
      document.querySelector('form[action^="/cart/add"] input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('form[id^="product-form-"] input[name="id"]') ||
      document.querySelector('input[name="id"]')
    );
  }

  function isVariantControl(el) {
    return !!(
      el &&
      el.matches &&
      el.matches(
        "variant-radios input, variant-selects select, .product-form__input input, .product-form__input select"
      )
    );
  }

  let pendingVariantId = "";
  let pendingMeta = {};
  let rafId = 0;
  let lastHandledVariantId = "";
  let lastSeenInputValue = "";
  let boundInput = null;
  let inputObserver = null;

  function cancelScheduledRun() {
    if (!rafId) return;
    cancelAnimationFrame(rafId);
    rafId = 0;
  }

  function flushVariantChange() {
    rafId = 0;

    const id = String(pendingVariantId || "").trim();
    const meta = pendingMeta || {};

    if (!id) return;
    if (id === lastHandledVariantId && !meta.force) return;

    lastHandledVariantId = id;
    lastSeenInputValue = id;

    if (typeof window.__APPLY_PRODUCTDATA_VARIANT_UI__ === "function") {
      window.__APPLY_PRODUCTDATA_VARIANT_UI__(id);
    }

    if (typeof window.__SYNC_GALLERY_TO_VARIANT__ === "function") {
      window.__SYNC_GALLERY_TO_VARIANT__(id, meta);
    }
  }

  function scheduleVariantChange(variantId, meta = {}) {
    const id = String(variantId || "").trim();
    if (!id) return;

    pendingVariantId = id;
    pendingMeta = meta;

    cancelScheduledRun();
    rafId = requestAnimationFrame(flushVariantChange);
  }

  function runFromInput(meta = {}) {
    const input = getVariantIdInput();
    const id = input?.value ? String(input.value).trim() : "";
    if (!id) return;
    scheduleVariantChange(id, meta);
  }

  function bindInputWatchers() {
    const input = getVariantIdInput();
    if (!input || input === boundInput) return;

    boundInput = input;

    input.addEventListener("input", () => runFromInput({ source: "id-input" }));
    input.addEventListener("change", () => runFromInput({ source: "id-input" }));

    if (inputObserver) {
      try {
        inputObserver.disconnect();
      } catch (e) {}
      inputObserver = null;
    }

    inputObserver = new MutationObserver(() => runFromInput({ source: "id-input-attr" }));
    inputObserver.observe(input, { attributes: true, attributeFilter: ["value"] });
  }

  window.__SCHEDULE_VARIANT_CHANGE__ = scheduleVariantChange;

  window.__ON_VARIANT_ID_CHANGED__ = function (variantId, meta = {}) {
    scheduleVariantChange(variantId, meta);
  };

  document.addEventListener(
    "change",
    (e) => {
      const target = e.target instanceof Element ? e.target : null;
      if (!isVariantControl(target)) return;

      requestAnimationFrame(() => runFromInput({ source: "variant-control-change" }));
    },
    true
  );

  document.addEventListener(
    "input",
    (e) => {
      const target = e.target instanceof Element ? e.target : null;
      if (!isVariantControl(target)) return;

      requestAnimationFrame(() => runFromInput({ source: "variant-control-input" }));
    },
    true
  );

  document.addEventListener("variant:change", (e) => {
    const detailVariantId = e?.detail?.variant?.id ? String(e.detail.variant.id).trim() : "";
    if (detailVariantId) {
      scheduleVariantChange(detailVariantId, {
        source: e?.detail?.source || "variant:change",
      });
      return;
    }

    requestAnimationFrame(() => runFromInput({ source: "variant:change" }));
  });

  document.addEventListener("DOMContentLoaded", () => {
    bindInputWatchers();
    runFromInput({ force: true, source: "dom-ready" });
  });

  document.addEventListener("shopify:section:load", bindInputWatchers);
  document.addEventListener("shopify:section:reorder", bindInputWatchers);
  document.addEventListener("shopify:section:select", bindInputWatchers);

  setInterval(() => {
    bindInputWatchers();

    const input = getVariantIdInput();
    const current = input?.value ? String(input.value).trim() : "";
    if (!current || current === lastSeenInputValue) return;

    lastSeenInputValue = current;
    scheduleVariantChange(current, { source: "fallback-poll" });
  }, 450);
})();

/* =======================================================
   ✅ Kit Template Bridge: Variant <-> Gallery (Desktop + Mobile)
   - Desktop (Dawn gallery thumbs) -> Variant
   - Mobile (AI gallery thumb/swipe) -> Variant
   - Variant change -> updates BOTH galleries
   - Faster on older iPhones by caching gallery lookups and syncing by media id first
======================================================= */
document.addEventListener("DOMContentLoaded", function () {
  const productData = window.ProductData || {};
  const variants = Array.isArray(productData.variants) ? productData.variants : [];

  function normalizeLoose(s) {
    return String(s || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ")
      .replace(/[-_]+/g, " ");
  }

  function getVariantById(id) {
    const vid = Number(id);
    if (!vid || !variants.length) return null;
    return variants.find((v) => Number(v.id) === vid) || null;
  }

  const optionToVariantId = new Map();
  const variantById = new Map();

  variants.forEach((v) => {
    variantById.set(String(v.id), v);

    [v.option1, v.option2, v.option3].forEach((opt) => {
      const key = normalizeLoose(opt);
      if (key && !optionToVariantId.has(key)) optionToVariantId.set(key, String(v.id));
    });

    const fmAlt = v.featured_media?.alt || "";
    const fiAlt = v.featured_image?.alt || "";
    const a1 = normalizeLoose(fmAlt);
    const a2 = normalizeLoose(fiAlt);
    if (a1 && !optionToVariantId.has(a1)) optionToVariantId.set(a1, String(v.id));
    if (a2 && !optionToVariantId.has(a2)) optionToVariantId.set(a2, String(v.id));
  });

  function getAllVariantIdInputs() {
    const inputs = Array.from(document.querySelectorAll('input[name="id"]')).filter(
      (i) =>
        i.closest("form") &&
        /\/cart\/add/.test(i.closest("form")?.getAttribute("action") || "/cart/add")
    );

    return inputs.length
      ? inputs
      : Array.from(document.querySelectorAll('form[action*="/cart/add"] input[name="id"]'));
  }

  function setBridgeLock(ms = 140) {
    window.__VARIANT_GALLERY_BRIDGE_LOCK__ = true;
    clearTimeout(window.__VARIANT_GALLERY_BRIDGE_LOCK_T__);
    window.__VARIANT_GALLERY_BRIDGE_LOCK_T__ = setTimeout(() => {
      window.__VARIANT_GALLERY_BRIDGE_LOCK__ = false;
    }, ms);
  }

  function setVariantIdEverywhere(variantId, meta = {}) {
    const id = String(variantId || "").trim();
    if (!id) return;

    const currentInput =
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('input[name="id"]');

    const currentId = currentInput ? String(currentInput.value || "").trim() : "";
    if (currentId === id && !meta.force) {
      if (typeof window.__SCHEDULE_VARIANT_CHANGE__ === "function") {
        window.__SCHEDULE_VARIANT_CHANGE__(id, meta);
      }
      return;
    }

    setBridgeLock(120);

    getAllVariantIdInputs().forEach((input) => {
      if (String(input.value || "").trim() === id) return;
      input.value = id;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    try {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", id);
      window.history.replaceState({}, "", url.toString());
    } catch (e) {}

    const vObj = variantById.get(id) || getVariantById(id);
    document.dispatchEvent(
      new CustomEvent("variant:change", {
        bubbles: true,
        detail: { variant: vObj, source: meta.source || "bridge" },
      })
    );

    if (typeof window.__SCHEDULE_VARIANT_CHANGE__ === "function") {
      window.__SCHEDULE_VARIANT_CHANGE__(id, meta);
    } else if (typeof window.__ON_VARIANT_ID_CHANGED__ === "function") {
      window.__ON_VARIANT_ID_CHANGED__(id, meta);
    }
  }

  const galleryCache = {
    built: false,
    root: null,
    aiThumbs: [],
    dawnButtons: [],
    aiByAlt: new Map(),
    dawnByAlt: new Map(),
    dawnByVariantId: new Map(),
    dawnByMediaId: new Map(),
  };

  function normalizeMediaId(value) {
    if (value == null) return "";
    const str = String(value).trim();
    if (!str) return "";
    const parts = str.split("-");
    return parts[parts.length - 1];
  }

  function invalidateGalleryCache() {
    galleryCache.built = false;
    galleryCache.root = null;
    galleryCache.aiThumbs = [];
    galleryCache.dawnButtons = [];
    galleryCache.aiByAlt = new Map();
    galleryCache.dawnByAlt = new Map();
    galleryCache.dawnByVariantId = new Map();
    galleryCache.dawnByMediaId = new Map();
  }

  function buildGalleryCache() {
    if (galleryCache.built) return galleryCache;

    invalidateGalleryCache();

    const root =
      document.querySelector("#MediaGallery") ||
      document.querySelector('[data-ai-gallery="true"]') ||
      document.querySelector(".product__media-wrapper") ||
      document;

    galleryCache.root = root;

    galleryCache.aiThumbs = Array.from(
      document.querySelectorAll('[data-ai-gallery="true"] [class*="ai-product-gallery-thumbnail-"]')
    );

    galleryCache.aiThumbs.forEach((thumb) => {
      const img = thumb.querySelector("img[alt]");
      const alt = normalizeLoose(img?.getAttribute("alt") || "");
      if (alt && !galleryCache.aiByAlt.has(alt)) galleryCache.aiByAlt.set(alt, thumb);
    });

    galleryCache.dawnButtons = Array.from(root.querySelectorAll("button.thumbnail"));

    galleryCache.dawnButtons.forEach((btn) => {
      const img = btn.querySelector("img[alt]");
      const alt = normalizeLoose(img?.getAttribute("alt") || "");
      const li = btn.closest("li");
      const variantId = String(li?.getAttribute("data-variant-id") || "").trim();

      const rawMediaId =
        btn.getAttribute("data-media-id") ||
        li?.getAttribute("data-media-id") ||
        btn.getAttribute("aria-controls") ||
        btn.getAttribute("data-target") ||
        "";
      const mediaId = normalizeMediaId(rawMediaId);

      if (alt && !galleryCache.dawnByAlt.has(alt)) galleryCache.dawnByAlt.set(alt, btn);
      if (variantId && !galleryCache.dawnByVariantId.has(variantId)) {
        galleryCache.dawnByVariantId.set(variantId, btn);
      }
      if (mediaId && !galleryCache.dawnByMediaId.has(mediaId)) {
        galleryCache.dawnByMediaId.set(mediaId, btn);
      }
    });

    galleryCache.built = true;
    return galleryCache;
  }

  const galleryMutationTarget =
    document.querySelector("#MediaGallery") ||
    document.querySelector('[data-ai-gallery="true"]') ||
    document.querySelector(".product__media-wrapper");

  if (galleryMutationTarget) {
    let cacheInvalidateRaf = 0;
    const cacheObserver = new MutationObserver(() => {
      if (cacheInvalidateRaf) cancelAnimationFrame(cacheInvalidateRaf);
      cacheInvalidateRaf = requestAnimationFrame(() => {
        invalidateGalleryCache();
      });
    });

    cacheObserver.observe(galleryMutationTarget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "aria-current", "aria-selected", "data-media-id", "data-variant-id"],
    });
  }

  function clickEl(el) {
    if (!el) return false;
    const clickable = el.matches("button, a, [role='button']")
      ? el
      : el.querySelector("button, a, [role='button']") || el;

    clickable.dispatchEvent(
      new MouseEvent("click", { bubbles: true, cancelable: true, view: window })
    );
    return true;
  }

  function getActiveAiThumb() {
    return document.querySelector(
      '[data-ai-gallery="true"] [class*="ai-product-gallery-thumbnail-"].active, ' +
        '[data-ai-gallery="true"] [class*="ai-product-gallery-thumbnail-"][aria-current="true"], ' +
        '[data-ai-gallery="true"] [class*="ai-product-gallery-thumbnail-"][aria-selected="true"]'
    );
  }

  function getActiveDawnThumb() {
    const root = buildGalleryCache().root || document;
    return root.querySelector(
      'button.thumbnail[aria-current="true"], button.thumbnail[aria-selected="true"], li.thumbnail-list__item.is-active button.thumbnail'
    );
  }

  function isSameAiThumb(thumb) {
    if (!thumb) return false;
    return getActiveAiThumb() === thumb;
  }

  function isSameDawnThumb(btn) {
    if (!btn) return false;
    return getActiveDawnThumb() === btn;
  }

  function findAiThumbByAlt(alt) {
    const target = normalizeLoose(alt);
    if (!target) return null;

    const cache = buildGalleryCache();
    if (cache.aiByAlt.has(target)) return cache.aiByAlt.get(target);

    for (const [key, thumb] of cache.aiByAlt.entries()) {
      if (key.includes(target) || target.includes(key)) return thumb;
    }

    return null;
  }

  function findDawnThumbByAltOrVariantId(altKey, variantId) {
    const cache = buildGalleryCache();
    const target = normalizeLoose(altKey);
    const vid = String(variantId || "").trim();

    if (target && cache.dawnByAlt.has(target)) return cache.dawnByAlt.get(target);
    if (vid && cache.dawnByVariantId.has(vid)) return cache.dawnByVariantId.get(vid);

    if (target) {
      for (const [key, btn] of cache.dawnByAlt.entries()) {
        if (key.includes(target) || target.includes(key)) return btn;
      }
    }

    return null;
  }

  function findDawnThumbByMediaId(mediaId) {
    const id = normalizeMediaId(mediaId);
    if (!id) return null;
    return buildGalleryCache().dawnByMediaId.get(id) || null;
  }
  function getVisibleVariantSelectsRoot() {
    const roots = Array.from(document.querySelectorAll("variant-selects"));
    if (!roots.length) return null;

    return (
      roots.find((el) => {
        const style = window.getComputedStyle(el);
        const rect = el.getBoundingClientRect();
        return (
          style.display !== "none" &&
          style.visibility !== "hidden" &&
          rect.width > 0 &&
          rect.height > 0
        );
      }) || roots[0]
    );
  }

  function getSelectedOptionsFromUi() {
    const root = getVisibleVariantSelectsRoot();
    if (!root) return [];

    const fieldsets = Array.from(root.querySelectorAll("fieldset.product-form__input"));

    return fieldsets.map((fieldset) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked) return String(checked.value || "").trim();

      const select = fieldset.querySelector("select");
      if (select) return String(select.value || "").trim();

      return "";
    });
  }

  function findVariantForGalleryAlt(alt) {
    const key = normalizeLoose(alt);
    if (!key) return null;

    const selected = getSelectedOptionsFromUi();

    // Prefer a variant whose media alt matches AND preserves current other selected options
    let best =
      variants.find((v) => {
        const mediaAlt = normalizeLoose(v.featured_media?.alt || v.featured_image?.alt || "");
        if (mediaAlt !== key) return false;

        const otherOptionsMatch =
          (!selected[0] || normalizeLoose(v.option1) === normalizeLoose(selected[0])) ||
          (!selected[1] || normalizeLoose(v.option2) === normalizeLoose(selected[1])) ||
          (!selected[2] || normalizeLoose(v.option3) === normalizeLoose(selected[2]));

        return otherOptionsMatch;
      }) || null;

    if (best) return best;

    // Fallback: exact media-alt match
    best =
      variants.find((v) => {
        const mediaAlt = normalizeLoose(v.featured_media?.alt || v.featured_image?.alt || "");
        return mediaAlt === key;
      }) || null;

    if (best) return best;

    // Final fallback: old loose map
    const mapped = optionToVariantId.get(key);
    return mapped ? getVariantById(mapped) : null;
  }

   function syncUiControlsToVariant(variant) {
    if (!variant) return;
    setBridgeLock(400);
    const root = getVisibleVariantSelectsRoot();
    if (!root) return;

    const wanted = [
      String(variant.option1 || "").trim(),
      String(variant.option2 || "").trim(),
      String(variant.option3 || "").trim(),
    ];

    const fieldsets = Array.from(root.querySelectorAll("fieldset.product-form__input"));

    fieldsets.forEach((fieldset, index) => {
      const wantedValue = wanted[index];
      if (!wantedValue) return;

      const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      const selects = Array.from(fieldset.querySelectorAll("select"));

      let matchedRadio = null;

      radios.forEach((radio) => {
        const isMatch = normalizeLoose(radio.value) === normalizeLoose(wantedValue);
        const label = radio.nextElementSibling && radio.nextElementSibling.tagName === "LABEL"
          ? radio.nextElementSibling
          : null;

        radio.checked = isMatch;

        if (isMatch) {
          radio.setAttribute("checked", "checked");
          radio.setAttribute("aria-checked", "true");
          matchedRadio = radio;
        } else {
          radio.removeAttribute("checked");
          radio.setAttribute("aria-checked", "false");

          // kill stale focus ring / stale selected classes on previous swatches
          radio.blur?.();

          if (label) {
            label.classList.remove("is-selected", "selected", "active", "is-active", "focused");
            label.removeAttribute("aria-current");
            label.style.outline = "none";
            label.style.boxShadow = "none";
          }
        }
      });

      if (matchedRadio) {
        const label = matchedRadio.nextElementSibling &&
          matchedRadio.nextElementSibling.tagName === "LABEL"
          ? matchedRadio.nextElementSibling
          : null;

        if (label) {
          fieldset.querySelectorAll("label").forEach((l) => {
            l.classList.remove("is-selected", "selected", "active", "is-active", "focused");
            l.removeAttribute("aria-current");
            l.style.outline = "none";
            l.style.boxShadow = "none";
          });

          label.classList.add("is-selected");
          label.setAttribute("aria-current", "true");
          label.style.outline = "";
          label.style.boxShadow = "";
        }

        // keep the actual variant logic in sync
        matchedRadio.dispatchEvent(new Event("input", { bubbles: true }));
        matchedRadio.dispatchEvent(new Event("change", { bubbles: true }));

        // remove browser focus ring from the previously focused swatch
        requestAnimationFrame(() => {
          radios.forEach((r) => {
            if (r !== matchedRadio) r.blur?.();
          });
        });
      }

      selects.forEach((select) => {
        if (normalizeLoose(select.value) !== normalizeLoose(wantedValue)) {
          select.value = wantedValue;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    });
  }
  document.addEventListener(
    "click",
    function (e) {
      if (window.__VARIANT_GALLERY_BRIDGE_LOCK__) return;

      const target = e.target instanceof Element ? e.target : null;
      if (!target) return;

      const btn = target.closest("button.thumbnail");
      if (!btn) return;

      const img = btn.querySelector("img[alt]");
      const alt = img ? img.getAttribute("alt") : "";
      const li = btn.closest("li");
      const dataColor = li ? li.getAttribute("data-color") : "";
      const dataVariantId = li ? li.getAttribute("data-variant-id") : "";

      const key = normalizeLoose(alt || dataColor);
      const mapped =
        (key && optionToVariantId.get(key)) || (dataVariantId ? String(dataVariantId) : null);

      if (!mapped) return;

      if (window.innerWidth > 749) {
        const scrollY = window.scrollY;
        const scrollX = window.scrollX;

        requestAnimationFrame(() => {
          setVariantIdEverywhere(mapped, { source: "desktop-thumb" });
          requestAnimationFrame(() => window.scrollTo(scrollX, scrollY));
        });
        return;
      }

      setVariantIdEverywhere(mapped, { source: "desktop-thumb" });
    },
    true
  );

document.addEventListener(
    "ai-gallery:slide-change",
    function (e) {
      if (window.__VARIANT_GALLERY_BRIDGE_LOCK__) return;
      if (window.__GALLERY_VARIANT_CHANGE__) return;

      const alt = e?.detail?.alt || "";
      const source = e?.detail?.source || "";

      // Block events we fired ourselves from v8
      if (source === 'v8-swatch') return;

      const variant = findVariantForGalleryAlt(alt);
      if (!variant) return;

      // Lock gallery sync so performGallerySync can't revert the slide
      // while syncUiControlsToVariant is dispatching change events
      window.__GALLERY_VARIANT_CHANGE__ = true;
      clearTimeout(window.__GALLERY_VARIANT_CHANGE_T__);
      window.__GALLERY_VARIANT_CHANGE_T__ = setTimeout(() => {
        window.__GALLERY_VARIANT_CHANGE__ = false;
      }, 600);

      setBridgeLock(400);
      syncUiControlsToVariant(variant);
      setVariantIdEverywhere(String(variant.id), { source: "ai-gallery" });
    },
    true
  );

  let syncRaf = 0;
  let pendingSyncVariantId = "";
  let lastSyncedMediaKey = "";

  function performGallerySync(variantId, meta = {}) {
     if (window.__GALLERY_VARIANT_CHANGE__) return;
    const id = String(variantId || "").trim();
    const v = variantById.get(id) || getVariantById(id);
    if (!v) return;

    const mediaId =
      normalizeMediaId(v.featured_media?.id) ||
      normalizeMediaId(v.featured_image?.id) ||
      "";

    const key =
      (v.option1 || v.option2 || v.option3 || "").trim() ||
      (v.featured_media?.alt || "") ||
      (v.featured_image?.alt || "");

    const syncKey = [id, mediaId, normalizeLoose(key)].filter(Boolean).join("|");
    if (syncKey && syncKey === lastSyncedMediaKey && !meta.force) return;

    const aiThumb = findAiThumbByAlt(key);
    if (aiThumb && !isSameAiThumb(aiThumb)) {
      lastSyncedMediaKey = syncKey;
      setBridgeLock(180);
      clickEl(aiThumb);
      return;
    }

    const dawnByMedia = mediaId ? findDawnThumbByMediaId(mediaId) : null;
    if (dawnByMedia && !isSameDawnThumb(dawnByMedia)) {
      lastSyncedMediaKey = syncKey;
      setBridgeLock(180);
      clickEl(dawnByMedia);
      return;
    }

    const dawnByAltOrVariant = findDawnThumbByAltOrVariantId(key, v.id);
    if (dawnByAltOrVariant && !isSameDawnThumb(dawnByAltOrVariant)) {
      lastSyncedMediaKey = syncKey;
      setBridgeLock(180);
      clickEl(dawnByAltOrVariant);
      return;
    }

    lastSyncedMediaKey = syncKey;
  }

 window.__SYNC_GALLERY_TO_VARIANT__ = function (variantId, meta = {}) {
    if (window.__GALLERY_VARIANT_CHANGE__) return;
    pendingSyncVariantId = String(variantId || "").trim();
    if (!pendingSyncVariantId) return;

    if (syncRaf) cancelAnimationFrame(syncRaf);
    syncRaf = requestAnimationFrame(() => {
      syncRaf = 0;
      if (window.__GALLERY_VARIANT_CHANGE__) return;
      performGallerySync(pendingSyncVariantId, meta);
    });
  };

  const firstIdInput =
    document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
    document.querySelector('input[name="id"]');

  if (firstIdInput?.value && typeof window.__SYNC_GALLERY_TO_VARIANT__ === "function") {
    window.__SYNC_GALLERY_TO_VARIANT__(firstIdInput.value, { force: true, source: "initial-sync" });
  }
});

/* =======================================================
   Custom Variant Availability Fix - generic v22
   ✅ Works with Length/Diameter
   ✅ Works with Size/Length
   ✅ Uses real product option names instead of hardcoding
======================================================= */
function normalizeOptionValue(val) {
  if (!val) return "";
  return String(val).trim().toLowerCase().replace(/\s+/g, " ");
}

function normalizeDiameter(val) {
  if (!val) return "";
  const cleaned = String(val).trim().replace(/\s+/g, "").replace(/mm$/i, "");
  const num = parseFloat(cleaned);
  return isNaN(num) ? cleaned.toLowerCase() : num.toFixed(2) + "mm";
}

function normalizeByOptionName(optionName, value) {
  const name = String(optionName || "").trim().toLowerCase();
  if (name.includes("diameter")) return normalizeDiameter(value);
  return normalizeOptionValue(value);
}

function getVariantsSafe(root) {
  if (window.__variantsCache) return window.__variantsCache;

  const localJson = root?.querySelector('script[type="application/json"][data-variant-json]');
  if (localJson) {
    try {
      const v = JSON.parse(localJson.textContent || "[]");
      if (Array.isArray(v)) return v;
    } catch (e) {}
  }

  if (window.ProductData?.variants && Array.isArray(window.ProductData.variants)) return window.ProductData.variants;
  if (window.productData?.variants && Array.isArray(window.productData.variants)) return window.productData.variants;

  const anyJson =
    document.querySelector('script[type="application/json"][data-variant-json]') ||
    document.querySelector("[data-variant-json]");
  if (anyJson) {
    try {
      const v = JSON.parse(anyJson.textContent || "[]");
      if (Array.isArray(v)) return v;
    } catch (e) {}
  }

  return [];
}

function getProductOptionNames() {
  const opts = window.ProductData?.options;
  if (Array.isArray(opts) && opts.length) return opts.map((o) => String(o || "").trim());
  return [];
}

function findFieldsetAfterLegend(root, legendIncludes) {
  const legends = Array.from(root.querySelectorAll("legend.form__label"));
  const wanted = String(legendIncludes || "").trim().toLowerCase();

  for (const leg of legends) {
    const t = (leg.textContent || "").trim().toLowerCase();
    if (!t.includes(wanted)) continue;

    let el = leg.nextElementSibling;
    while (el && el.tagName !== "FIELDSET") el = el.nextElementSibling;

    if (el && el.tagName === "FIELDSET") return el;
  }

  return null;
}

function applyGenericAvailability(reason = "init") {
  const vs =
    document.querySelector("variant-selects") ||
    document.getElementById("variant-selects-template--27012270784795__main");

  if (!vs) return;

  const optionNames = getProductOptionNames();
  if (optionNames.length < 2) return;

  const option1Name = optionNames[0];
  const option2Name = optionNames[1];

  const option1Fieldset = findFieldsetAfterLegend(vs, option1Name);
  const option2Fieldset = findFieldsetAfterLegend(vs, option2Name);

  if (!option1Fieldset || !option2Fieldset) return;

  const selectedOption1Input = option1Fieldset.querySelector('input[type="radio"]:checked');
  if (!selectedOption1Input) return;

  const selectedOption1 = (selectedOption1Input.value || "").trim();
  const selectedOption1Norm = normalizeByOptionName(option1Name, selectedOption1);

  const variants = getVariantsSafe(vs);
  if (!variants.length) return;

  const allowed = new Set();

  variants.forEach((v) => {
    const vOpt1 = normalizeByOptionName(option1Name, v.option1 || "");
    const vOpt2 = normalizeByOptionName(option2Name, v.option2 || "");

    if (vOpt1 === selectedOption1Norm && v.available) {
      allowed.add(vOpt2);
    }
  });

  option2Fieldset.querySelectorAll('input[type="radio"]').forEach((radio) => {
    const rawValue = (radio.value || "").trim();
    const normValue = normalizeByOptionName(option2Name, rawValue);
    const enable = allowed.has(normValue);

    // Skip entirely when nothing would change — avoids re-triggering the observer
    if (radio.disabled === !enable) {
      const lbl = radio.nextElementSibling;
      if (!lbl || lbl.tagName !== "LABEL") return;
      if (lbl.classList.contains("disabled") === !enable) return;
    }

    if (enable) {
      radio.disabled = false;
      radio.removeAttribute("disabled");
      radio.classList.remove("disabled");
      radio.setAttribute("aria-disabled", "false");
    } else {
      radio.disabled = true;
      radio.setAttribute("disabled", "disabled");
      radio.classList.add("disabled");
      radio.setAttribute("aria-disabled", "true");
    }

    const label = radio.nextElementSibling;
    if (label && label.tagName === "LABEL") {
      label.classList.toggle("disabled", !enable);
      label.classList.toggle("unavailable", !enable);
    }
  });
}

function initAvailV22() {
  applyGenericAvailability("init");

 document.addEventListener("change", (e) => {
  const target = e.target instanceof Element ? e.target : null;
  if (!target) return;

  if (target.matches('variant-selects input[type="radio"]')) {
    applyGenericAvailability("change");
  }
});

  let availRaf = 0;
  const obs = new MutationObserver(() => {
    if (availRaf) return;
    availRaf = requestAnimationFrame(() => {
      availRaf = 0;
      applyGenericAvailability("mutation");
    });
  });
  obs.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", initAvailV22);

/* =======================================================
   ✅ Price + SKU update from window.ProductData
   - Batches UI work
   - Avoids repeated observers / duplicate retries
======================================================= */
(function () {
  function getVariantById(id) {
    const vid = Number(id);
    const variants = window.ProductData?.variants;
    if (!vid || !Array.isArray(variants)) return null;
    return variants.find((v) => Number(v.id) === vid) || null;
  }

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, "${{amount}}");
    }

    const dollars = Number(cents || 0) / 100;
    return `$${dollars.toFixed(2)}`;
  }

  function updateSku(variant) {
    if (!variant) return;

    const skuEls = document.querySelectorAll(".product__sku, [data-sku]");
    skuEls.forEach((el) => {
      const nextSku = variant.sku || "";

      if (/sku/i.test(el.textContent) && el.textContent.includes(":")) {
        const parts = el.textContent.split(":");
        const nextText = parts[0] + ": " + nextSku;
        if (el.textContent !== nextText) el.textContent = nextText;
      } else if (el.textContent !== nextSku) {
        el.textContent = nextSku;
      }
    });
  }

  function updatePrice(variant) {
    if (!variant) return;

    const main = document.querySelector("main#MainContent") || document;

    const regularTargets = main.querySelectorAll(
      ".price-item--regular, .price__regular .price-item, [data-regular-price]"
    );
    const saleTargets = main.querySelectorAll(
      ".price-item--sale, .price__sale .price-item, [data-sale-price]"
    );

    if (!regularTargets.length && !saleTargets.length) return;

    const price = formatMoney(variant.price);
    const compareAt = variant.compare_at_price ? formatMoney(variant.compare_at_price) : null;
    const onSale = compareAt && variant.compare_at_price > variant.price;
    const regularText = onSale ? compareAt : price;

    saleTargets.forEach((el) => {
      if (el.textContent !== price) el.textContent = price;
    });

    regularTargets.forEach((el) => {
      if (el.textContent !== regularText) el.textContent = regularText;
    });
  }

  function applyVariantUi(variantId) {
    const v = getVariantById(variantId);
    if (!v) return;

    if (window.__IS_KIT_TEMPLATE__) {
      const priceElement = document.querySelector("custom-price");
      if (priceElement && typeof priceElement.updatePrice === "function") {
        priceElement.updatePrice();
      } else {
        updatePrice(v);
      }
    } else {
      updatePrice(v);
    }

    updateSku(v);
  }

  function getCurrentVariantIdFallback() {
    const idInput =
      document.querySelector('product-form form input[name="id"]') ||
      document.querySelector('form[action^="/cart/add"] input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector(".product-variant-id");

    return idInput?.value ? String(idInput.value).trim() : "";
  }

  function applyKitYarnSetOnce(variantId) {
  const id = String(variantId || "").trim();
  if (!id) return false;

  const target = document.getElementById("yarn_" + id);
  if (!target) return false; // bail before touching any DOM state — leaves the previous set intact

  document.querySelectorAll(".yarnSets").forEach((el) => (el.style.display = "none"));
  document.querySelectorAll(".yarnSets .addon-item").forEach((el) =>
    el.classList.remove("active--item")
  );

  target.style.display = "";
  target.style.removeProperty("display");
  target.querySelectorAll(".addon-item").forEach((el) => el.classList.add("active--item"));
  return true;
}

  function updateKitPrice() {
    const priceElement = document.querySelector("custom-price");
    if (priceElement && typeof priceElement.updatePrice === "function") {
      priceElement.updatePrice();
    }
  }

  function applyKitYarnSetWithRetry(variantId, tries = 4, delay = 20) {
    const wanted = String(variantId || "").trim() || getCurrentVariantIdFallback();
    if (!wanted) return;

    let attempt = 0;

    const tick = () => {
      const current = getCurrentVariantIdFallback() || wanted;
      const ok = applyKitYarnSetOnce(current);

      if (ok) {
        updateKitPrice();
        return;
      }

      attempt += 1;
      if (attempt >= tries) return;
      setTimeout(tick, delay);
    };

    tick();
  }

  let pendingVariantId = "";
  let uiRaf = 0;
  let settleTimer = 0;
  let settleObserver = null;
  let lastAppliedVariantId = "";

  function disconnectSettleObserver() {
    if (settleObserver) {
      try {
        settleObserver.disconnect();
      } catch (e) {}
      settleObserver = null;
    }
    if (settleTimer) {
      clearTimeout(settleTimer);
      settleTimer = 0;
    }
  }

  function settleAfterDomSwap(variantId) {
    disconnectSettleObserver();

    const watchRoot =
      document.querySelector("product-info") ||
      document.querySelector("main#MainContent") ||
      document.body;

    let fired = false;

    settleObserver = new MutationObserver(() => {
      if (fired) return;
      fired = true;

      requestAnimationFrame(() => {
        disconnectSettleObserver();
        const current = getCurrentVariantIdFallback() || variantId;
        applyVariantUi(current);
        applyKitYarnSetWithRetry(current, 4, 20);
      });
    });

    settleObserver.observe(watchRoot, { childList: true, subtree: true });

    settleTimer = setTimeout(() => {
      disconnectSettleObserver();
    }, 220);
  }

  function flushPriceUi() {
    uiRaf = 0;

    const current = String(pendingVariantId || "").trim() || getCurrentVariantIdFallback();
    if (!current) return;
    if (current === lastAppliedVariantId) return;

    lastAppliedVariantId = current;

    applyVariantUi(current);
    applyKitYarnSetWithRetry(current, 4, 20);
    settleAfterDomSwap(current);
  }

  function schedulePriceUi(variantId) {
    pendingVariantId = String(variantId || "").trim() || getCurrentVariantIdFallback();
    if (!pendingVariantId) return;

    if (uiRaf) cancelAnimationFrame(uiRaf);
    uiRaf = requestAnimationFrame(flushPriceUi);
  }

  window.__APPLY_PRODUCTDATA_VARIANT_UI__ = function (variantId) {
    schedulePriceUi(variantId);
  };
})();

/* =======================================================
   Swatch select -> scroll user back to gallery top (mobile, smoother)
   TEMP DIAG: DISABLED FOR TEST 1
======================================================= */
(function () {
  function smoothScrollTo(targetY, duration = 900) {
    const startY = window.scrollY;
    const distance = targetY - startY;
    const startTime = performance.now();

    function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function animate(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeInOutQuad(progress);

      window.scrollTo(0, startY + distance * eased);

      if (progress < 1) requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  }

  document.addEventListener(
    "change",
    function (e) {
      const input = e.target;

      if (
        !input ||
        !input.matches(
          'input.swatch-input__input[type="radio"], input.swatch-input__input[type="checkbox"]'
        )
      )
        return;

      // Only on mobile
      if (window.innerWidth > 749) return;

      const gallery =
        document.querySelector('[data-ai-gallery="true"]') ||
        document.querySelector("product-media-gallery") ||
        document.querySelector(".product__media-wrapper");

      if (!gallery) return;

      const header =
        document.querySelector("sticky-header") ||
        document.querySelector(".header-wrapper") ||
        document.querySelector("#shopify-section-header");

      const offset = header ? header.getBoundingClientRect().height : 0;
      const top = gallery.getBoundingClientRect().top + window.scrollY - offset - 8;

      smoothScrollTo(top, 1000);
    },
    true
  );
})();

/* =======================================================
   ✅ Kits only: disable Dawn product-info ajax re-render
   Prevents the delayed “second” price update / flicker.
======================================================= */
(function () {
  if (!window.__DISABLE_DAWN_PRODUCT_INFO_RENDER__) return;

  function patchProductInfo() {
    const Ctor = customElements.get("product-info");
    if (!Ctor || !Ctor.prototype) return;

    const proto = Ctor.prototype;
    if (proto.__KIT_NO_RENDER_PATCH__) return;
    proto.__KIT_NO_RENDER_PATCH__ = true;

    // Stop Dawn from fetching + swapping HTML
    if (typeof proto.handleOptionValueChange === "function") {
      proto.__orig_handleOptionValueChange__ = proto.handleOptionValueChange;
      proto.handleOptionValueChange = function () {
        return; // ✅ no-op on kits
      };
    }

    // Extra safety
    if (typeof proto.renderProductInfo === "function") {
      proto.__orig_renderProductInfo__ = proto.renderProductInfo;
      proto.renderProductInfo = async function () {
        return; // ✅ no-op on kits
      };
    }
  }

  if (customElements.get("product-info")) patchProductInfo();
  else customElements.whenDefined("product-info").then(patchProductInfo).catch(() => {});
})();
/* =======================================================
   ✅ FAST: Sync visible option labels + VISIBLE radios only
   Targets the main product form, not hidden duplicate markup
======================================================= */
(function () {
  if (window.__FAST_OPTION_LABELS_V5__) return;
  window.__FAST_OPTION_LABELS_V5__ = true;

  function getVariantById(id) {
    const vid = Number(id);
    const variants = window.ProductData?.variants;
    if (!vid || !Array.isArray(variants)) return null;
    return variants.find((v) => Number(v.id) === vid) || null;
  }

  function norm(s) {
    return String(s || "").trim().toLowerCase();
  }

  function getMainProductRoot() {
    return (
      document.querySelector('product-info[id^="MainProduct-"]') ||
      document.querySelector(".product-info-standard") ||
      document
    );
  }

  function getVisibleVariantSelectsRoot() {
    const root = getMainProductRoot();

    const candidates = Array.from(root.querySelectorAll("variant-selects")).filter((el) => {
      const style = window.getComputedStyle(el);
      const rect = el.getBoundingClientRect();
      return (
        style.display !== "none" &&
        style.visibility !== "hidden" &&
        rect.width > 0 &&
        rect.height > 0
      );
    });

    return candidates[0] || root.querySelector("variant-selects") || null;
  }

  function updateVisibleLabels(variantId) {
    const v = getVariantById(variantId);
    if (!v) return;

    const root = getVisibleVariantSelectsRoot();
    if (!root) return;

    const values = [
      String(v.option1 || "").trim(),
      String(v.option2 || "").trim(),
      String(v.option3 || "").trim()
    ];

    const legends = Array.from(
      root.querySelectorAll("legend.form__label")
    );

    legends.forEach((legend, index) => {
      const span = legend.querySelector("[data-selected-value]");
      if (!span) return;

      const nextValue = values[index];
      if (nextValue && span.textContent !== nextValue) {
        span.textContent = nextValue;
      }
    });
  }

  function syncVisibleRadios(variantId) {
    const v = getVariantById(variantId);
    if (!v) return;

    const root = getVisibleVariantSelectsRoot();
    if (!root) return;

    const wantedValues = [
      String(v.option1 || "").trim(),
      String(v.option2 || "").trim(),
      String(v.option3 || "").trim()
    ];

    const fieldsets = Array.from(root.querySelectorAll("fieldset.product-form__input"));

    fieldsets.forEach((fieldset, index) => {
      const wanted = wantedValues[index];
      if (!wanted) return;

      const radios = Array.from(
        fieldset.querySelectorAll('input[type="radio"]')
      );

      if (!radios.length) return;

      let matchedRadio = null;

      radios.forEach((radio) => {
        const isMatch = norm(radio.value) === norm(wanted);
        radio.checked = isMatch;

        if (isMatch) {
          matchedRadio = radio;
          radio.setAttribute("checked", "checked");
        } else {
          radio.removeAttribute("checked");
        }
      });

      if (matchedRadio) {
        // force browser-visible UI state refresh
        matchedRadio.dispatchEvent(new Event("input", { bubbles: true }));
        matchedRadio.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  function syncVisibleOptionUi(variantId) {
    updateVisibleLabels(variantId);

    requestAnimationFrame(() => {
      syncVisibleRadios(variantId);
      updateVisibleLabels(variantId);

      requestAnimationFrame(() => {
        syncVisibleRadios(variantId);
        updateVisibleLabels(variantId);
      });
    });
  }

  const orig = window.__ON_VARIANT_ID_CHANGED__;

  window.__ON_VARIANT_ID_CHANGED__ = function (variantId, meta = {}) {
    const result =
      typeof orig === "function"
        ? orig.call(this, variantId, meta)
        : undefined;

    syncVisibleOptionUi(variantId);
    return result;
  };

  document.addEventListener("DOMContentLoaded", () => {
    const idInput =
      getMainProductRoot()?.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('input[name="id"]');

    if (idInput?.value) {
      syncVisibleOptionUi(idInput.value);
    }
  });
})();
/* =======================================================
   Clear add-to-cart error when variant changes
======================================================= */
document.addEventListener('change', function (e) {
  const target = e.target instanceof Element ? e.target : null;
  if (!target) return;

  const variantArea = target.closest('variant-selects');
  if (!variantArea) return;

  const productInfo = variantArea.closest('product-info');
  if (!productInfo) return;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const form = productInfo.querySelector('product-form, .product-form, form[action*="/cart/add"]');
      if (!form) return;

      const errorWrapper = form.parentElement?.querySelector('.product-form__error-message-wrapper')
        || productInfo.querySelector('.product-form__error-message-wrapper');

      const errorMessage = errorWrapper?.querySelector('.product-form__error-message');

      if (errorWrapper) {
        errorWrapper.setAttribute('hidden', '');
      }

      if (errorMessage) {
        errorMessage.textContent = '';
      }
    });
  });
});
/* =======================================================
   FIX v8 FINAL: Sync AI gallery when option2 (scent) changes
   - Calls gallery's own activateIndex (keeps currentIndex in sync)
   - __GALLERY_VARIANT_CHANGE__ lock blocks the variant bridge
   - No loop: bridge checks lock before updating variant
======================================================= */
(function () {
  window.__OPTION2_GALLERY_SYNC_V3__ = true;
  window.__OPTION2_GALLERY_SYNC_V4__ = true;
  window.__OPTION2_GALLERY_SYNC_V5__ = true;
  window.__OPTION2_GALLERY_SYNC_V6__ = true;
  window.__OPTION2_GALLERY_SYNC_V7__ = true;

  if (window.__OPTION2_GALLERY_SYNC_V8__) return;
  window.__OPTION2_GALLERY_SYNC_V8__ = true;

  function normalizeLoose(s) {
    return String(s || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function getCurrentSize() {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return '';
    const fieldsets = Array.from(variantSelects.querySelectorAll('fieldset.product-form__input'));
    if (!fieldsets[0]) return '';
    const checked = fieldsets[0].querySelector('input[type="radio"]:checked');
    return checked ? String(checked.value || '').trim() : '';
  }

  function findSlideIndexByAlt(targetAlt) {
    const target = normalizeLoose(targetAlt);
    if (!target) return -1;

    const slides = Array.from(
      document.querySelectorAll('[class*="ai-product-gallery-slide-"]')
    );

    // Exact match
    for (let i = 0; i < slides.length; i++) {
      const img = slides[i].querySelector('img[alt]');
      if (!img) continue;
      const alt = normalizeLoose(img.getAttribute('alt') || '');
      if (alt === target) return i;
    }

    // Partial match fallback
    for (let i = 0; i < slides.length; i++) {
      const img = slides[i].querySelector('img[alt]');
      if (!img) continue;
      const alt = normalizeLoose(img.getAttribute('alt') || '');
      if (alt.includes(target) || target.includes(alt)) return i;
    }

    return -1;
  }

  function activateGallerySlide(index) {
    const root = document.querySelector('[data-ai-gallery="true"]');
    if (!root) return false;

    // Use the gallery's own activateIndex if available (keeps currentIndex in sync)
    if (typeof root.__activateIndex === 'function') {
      root.__activateIndex(index, { source: 'v8-swatch' });
      return true;
    }

    // Fallback: direct class manipulation
    const slides = Array.from(root.querySelectorAll('[class*="ai-product-gallery-slide-"]'));
    const thumbs = Array.from(root.querySelectorAll('[class*="ai-product-gallery-thumbnail-"]'));

    slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
    thumbs.forEach((t, i) => t.classList.toggle('active', i === index));

    if (thumbs[index]) {
      thumbs[index].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    return true;
  }

  document.addEventListener('change', function (e) {
    if (window.__GALLERY_VARIANT_CHANGE__) return;
    if (window.__VARIANT_GALLERY_BRIDGE_LOCK__) return;

    const target = e.target instanceof Element ? e.target : null;
    if (!target) return;
    if (!target.matches('variant-selects input[type="radio"]')) return;

    const fieldset = target.closest('fieldset.product-form__input');
    if (!fieldset) return;

    const variantSelects = target.closest('variant-selects');
    if (!variantSelects) return;

    const allFieldsets = Array.from(
      variantSelects.querySelectorAll('fieldset.product-form__input')
    );
    const optionIndex = allFieldsets.indexOf(fieldset);

    if (optionIndex < 1) return;

    const swatchValue = String(target.value || '').trim();
    if (!swatchValue) return;

    // Lock immediately before anything else fires
    window.__GALLERY_VARIANT_CHANGE__ = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const size = getCurrentSize();
        const combinedAlt = size ? `${size} / ${swatchValue}` : swatchValue;

        let idx = findSlideIndexByAlt(combinedAlt);
        if (idx === -1) idx = findSlideIndexByAlt(swatchValue);

        if (idx === -1) {
          
          window.__GALLERY_VARIANT_CHANGE__ = false;
          return;
        }

       
        activateGallerySlide(idx);

        // Hold lock through Dawn's full async re-render cycle
        setTimeout(() => {
          window.__GALLERY_VARIANT_CHANGE__ = false;
        }, 1500);
      });
    });
  }, true);

  // Allow ai-gallery:slide-change through ONLY when we didn't trigger it
  document.addEventListener('ai-gallery:slide-change', function (e) {
    if (window.__GALLERY_VARIANT_CHANGE__ && e?.detail?.source === 'v8-swatch') {
      // We triggered this — stop it from updating the variant
      e.stopImmediatePropagation();
    }
  }, true);

})();